import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="text-center bg-white p-12 rounded-lg shadow-xl max-w-md w-full">
                <h2 className="text-3xl font-bold text-red-500 mb-4">Coming Soon</h2>
                <p className="text-lg text-gray-700 mb-6">Our Privacy Policy page is under construction. Stay tuned!</p>
                <p className="text-gray-500">We are working hard to bring you the best experience. Please check back later for updates.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
